module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/arrow2-31b73fea9ac9d5a8964b0729e230efd4.svg";